import { render, staticRenderFns } from "./StaticFileManager.vue?vue&type=template&id=27f0564a&"
import script from "./StaticFileManager.vue?vue&type=script&lang=js&"
export * from "./StaticFileManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports